import { render, staticRenderFns } from "./welcome-plan-information-modal.vue?vue&type=template&id=601432f5"
import script from "./welcome-plan-information-modal.vue?vue&type=script&lang=js"
export * from "./welcome-plan-information-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports